var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "topo" }, [
      _c("img", {
        attrs: { id: "logo", src: _vm.LOGO, alt: "sicarf", name: "logo" },
        on: { click: _vm.goHome }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _vm.hasListagemModelo
            ? [
                _vm.isVisualizarGestaoProcessos
                  ? _c(
                      "div",
                      { staticClass: "el-dropdown-link" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              id: "tooltip",
                              effect: "dark",
                              content: "Gestão processos/usuários",
                              placement: "bottom"
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "user-friends" },
                              on: { click: _vm.goToGestaoProcesso }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.$route.meta.isPublic
            ? _c("div", { staticClass: "user" }, [
                _c("div", { staticClass: "usuario" }, [
                  _c("i", { staticClass: "fas fa-user-circle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "descricao" }, [
                    _vm.nomeUsuario
                      ? _c("span", { staticClass: "nomePerfil" }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(
                                _vm.getPrimeiroEUltimoNome(_vm.nomeUsuario)
                              ) +
                              "\n            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.nomePerfil
                      ? _c("span", { staticClass: "nomePerfil" }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(_vm.nomePerfil) +
                              "\n            "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "logout" },
                  [
                    _c("app-action-button", {
                      attrs: {
                        icone: "sign-out-alt",
                        id: "button_logout",
                        cor: "#a7b2bb",
                        text: "Sair",
                        fontSize: "25"
                      },
                      on: { click: _vm.sair }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f11bcd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f11bcd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainHeader.vue
// module id = null
// module chunks = 